export const EFioParts = Object.freeze({
    NAME: 'NAME',
    SURNAME: 'SURNAME',
    PATRONYMIC: 'PATRONYMIC',
});
